// extracted by mini-css-extract-plugin
module.exports = {"flexLayout":"LayoutAware-module--flexLayout--1oi6I","negativeMargin":"LayoutAware-module--negativeMargin--1ZslI"};